import { makeStyles, createStyles } from '@material-ui/core/styles';
import CircularProgress, {
  CircularProgressProps
} from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      color: '#1a90ff',
      animationDuration: '850ms'
    },
    circle: {
      strokeLinecap: 'round'
    }
  })
);

export type SCircularLoaderProps = Omit<
  CircularProgressProps,
  'variant' | 'size' | 'thickness'
> & {
  /**
   * Size of the loader in pixels or CSS value
   * @default 50
   */
  size?: number | string;
  /**
   * Thickness of the loader stroke
   * @default 5
   */
  thickness?: number;
};

export function SCircularLoader({
  size = 50,
  thickness = 5,
  className,
  ...props
}: SCircularLoaderProps) {
  const classes = useStyles();

  return (
    <CircularProgress
      variant="indeterminate"
      disableShrink
      className={`${classes.root} ${className || ''}`}
      classes={{
        circle: classes.circle
      }}
      size={size}
      thickness={thickness}
      {...props}
    />
  );
}
